import {
  addDoc,
  collection,
  doc,
  increment,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "./firebase";

const TURMA_GAMES_COLLECTION = "jogo_turma";
const MEMBERS_COLLECTION = "jogador_turma";
const USERS_COLLECTION = "usuarios";

export const createTurmaJogo = async ({
  turmaId,
  participantesIds = [],
  createdBy,
}) => {
  if (!turmaId) {
    throw new Error("Turma inválida para criar jogo.");
  }
  const payload = {
    id_turma: turmaId,
    status: 1,
    participantes_ids: participantesIds,
    id_usuario_criador: createdBy || null,
    id_usuario_lider_assistencias: null,
    id_usuario_mvp: null,
    id_usuario_artilheiro: null,
    selecao_rodada: [],
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
  };
  const docRef = await addDoc(collection(db, TURMA_GAMES_COLLECTION), payload);
  return docRef.id;
};

export const updateTurmaJogoResumo = async ({ jogoId, data }) => {
  if (!jogoId) {
    throw new Error("Jogo inválido para atualização.");
  }
  const jogoRef = doc(db, TURMA_GAMES_COLLECTION, jogoId);
  await updateDoc(jogoRef, {
    ...data,
    updated_at: serverTimestamp(),
  });
};

export const incrementTurmaMemberStats = async ({ membershipId, stats, overall }) => {
  if (!membershipId) return;
  const memberRef = doc(db, MEMBERS_COLLECTION, membershipId);
  const payload = {};
  Object.entries(stats || {}).forEach(([key, value]) => {
    if (typeof value === "number" && value !== 0) {
      payload[key] = increment(value);
    }
  });
  if (typeof overall === "number" && !Number.isNaN(overall)) {
    payload.overall = overall;
  }
  if (Object.keys(payload).length === 0) {
    return;
  }
  payload.updated_at = serverTimestamp();
  await updateDoc(memberRef, payload);
};

export const incrementUsuarioStats = async ({ userId, stats, overall }) => {
  if (!userId || !stats) return;
  const userRef = doc(db, USERS_COLLECTION, userId);
  const payload = {};
  Object.entries(stats).forEach(([key, value]) => {
    if (typeof value === "number" && value !== 0) {
      payload[key] = increment(value);
    }
  });
  if (typeof overall === "number" && !Number.isNaN(overall)) {
    payload.overall = overall;
  }
  if (Object.keys(payload).length === 0) {
    return;
  }
  payload.updated_at = serverTimestamp();
  await updateDoc(userRef, payload);
};
